<template>
<div class="back" v-if="show" @click="announcementBACK" id="announcementBACK">
  <div class="dialogbox" :style="{
    width: `${width}px`,
    maxHeight: height ? `${height}px` : 'fit-content',
    borderRadius: mode==='image' ? 0 : '10px'
  }" :class="mode==='image'&&mode">
  <template v-if="mode==='content'">
    <div class="headerBox">
      <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="35" height="35" rx="17.5" fill="#CC9B6D"/>
      <g clip-path="url(#clip0_905_3007)">
      <mask id="mask0_905_3007" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="9" y="7" width="17" height="21">
      <path d="M25.9426 7.5H9.05762V27.5H25.9426V7.5Z" fill="white"/>
      </mask>
      <g mask="url(#mask0_905_3007)">
      <path d="M24.6139 19.4146V15.7121C24.6139 12.4784 22.4581 9.71326 19.4118 9.01045C19.1775 8.11997 18.3807 7.51086 17.4902 7.51086C16.5529 7.51086 15.7561 8.21393 15.5687 9.10416C12.7101 9.94779 10.6946 12.6658 10.6946 15.7121V19.1801C9.67874 19.8186 9.05985 20.9325 9.05444 22.1327V22.1795C9.05444 22.6481 9.14815 23.1169 9.33557 23.5386L9.38242 23.5854C9.52298 23.9134 9.80437 24.1477 10.1323 24.2414C10.2261 24.2882 10.3666 24.2882 10.554 24.2882H24.473C24.5668 24.2882 24.6605 24.2882 24.7542 24.2414C25.1761 24.1945 25.5041 23.9134 25.6447 23.5854C25.8321 23.1635 25.9258 22.6481 25.9258 22.1795V22.1327C25.926 21.0548 25.4575 20.0706 24.6139 19.4146ZM19.0835 25.3664H15.3813C15.3813 26.538 16.3186 27.4753 17.4902 27.4753C18.6618 27.4753 19.5992 26.538 19.5992 25.3664H19.0835Z" fill="white"/>
      </g>
      </g>
      <defs>
      <clipPath id="clip0_905_3007">
      <rect width="16.885" height="20" fill="white" transform="translate(9.05762 7.5)"/>
      </clipPath>
      </defs>
      </svg>
      {{label}}
      <hr>
      <button class="closeBtn" @click="$emit(last ? 'close' : 'NEXT')"></button>
    </div>
      <div class="content">
        <div class="content-text" v-html="content.replaceAll('\n', '<br>')"></div>
        <Btn :style="{margin: 'auto', marginBottom: '20px'}" :text="last ? '關閉' : '下一頁'" :bg="'var(--color-pri)'" @click="$emit(last ? 'close' : 'NEXT')"/>
    </div>
  </template>
  <template v-else>
    <img :src="`${VUE_APP_HOST}${image}`" :style="{resize: 'both', maxWidth: '50vw', maxHeight: '80vh', width: 'auto', height: 'auto'}"/>
    <button class="closeBtn2" @click="$emit(last ? 'close' : 'NEXT')"></button>
  </template>

  </div>
</div>
</template>

<script>
import Btn from '../components/btn/sqr40016.vue'
const { VUE_APP_BASE_URL, VUE_APP_HOST } = process.env
export default {
  name: 'dialogbox',
  data () {
    return {
      VUE_APP_BASE_URL,
      VUE_APP_HOST
    }
  },
  props: ['show', 'width', 'label', 'height', 'content', 'last', 'mode', 'image'],
  components: {
    Btn
  },
  methods: {
    announcementBACK (ev) {
      if (ev.target.id === 'announcementBACK') {
        this.$emit(this.last ? 'close' : 'NEXT')
      }
    }
  }

}
</script>

<style lang="scss" scoped>
@media screen and (orientation: landscape) {
.back {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 200;
  mix-blend-mode: normal;
  backdrop-filter: blur(8px);
  background: rgba(94, 94, 94, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}
.headerBox {
  width: 100%;
  height: 168px;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-inline: 27px;
  box-sizing: border-box;
  position: relative;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 35px;
  letter-spacing: 0.1em;
  border-radius: 10px 10px 0 0;
  color: var(--color-pri);
  gap: 6px;
  padding: 13px 13px 0 13px;
  svg {
    height: 35px;
  }
  hr {
    height: 1.5px;
    border: none;
    position: relative;
    width: calc(100% - 46px);
    background-color: var(--color-pri);
  }
}
.closeBtn {
  padding: 0;
  margin: 0;
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: var(--color-pri);
  border: none;
  z-index: 91;
  width: 30px;
  height: 31px;
  mask-image: url(./close.svg);
}
.closeBtn2 {
  padding: 0;
  margin: 0;
  position: absolute;
  top: -42px;
  right: -42px;
  background-color: #FFFFFF;
  border: none;
  z-index: 91;
  width: 30px;
  height: 31px;
  mask-image: url(./close.svg);
}
.dialogbox {
  border-radius: 10px;
  &::before {
    display: none!important;
  }
  padding: 0!important;
  margin: 0!important;
  height: fit-content;
  min-width: 480px;
  position: relative;
  background-color: #FFFFFF;
  z-index: 90;
  box-shadow: -4px 0px 15px rgba(0, 0, 0, 0.25);
  &.image {
    border-radius: 10px;
    display:flex;
    align-items: center;
    justify-content: center;
    max-width: 50vw;
    max-height: 90vh;
  }
}
.content-text {
  color: #787878;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 180%;
  padding-bottom: 20px;
  max-height: 60vh;
  max-width: 60vw;
  overflow: auto;
}
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0;
  width: 100%;
  color: #787878;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 180%;
  padding-bottom: 20px;
  padding-inline: 30px;
}
}
@media screen and (orientation: portrait) {
.back {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 200;
  mix-blend-mode: normal;
  backdrop-filter: blur(8px);
  background: rgba(94, 94, 94, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}
.headerBox {
  width: 100%;
  height: 168px;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-inline: 27px;
  box-sizing: border-box;
  position: relative;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 35px;
  letter-spacing: 0.1em;
  border-radius: 10px 10px 0 0;
  color: var(--color-pri);
  gap: 6px;
  padding: 13px 13px 0 13px;
  svg {
    height: 35px;
  }
  hr {
    height: 1.5px;
    border: none;
    position: relative;
    width: calc(100% - 46px);
    background-color: var(--color-pri);
  }
}
.closeBtn {
  padding: 0;
  margin: 0;
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: var(--color-pri);
  border: none;
  z-index: 91;
  width: 30px;
  height: 31px;
  mask-image: url(./close.svg);
}
.closeBtn2 {
  padding: 0;
  margin: 0;
  position: absolute;
  top: -42px;
  right: -42px;
  background-color: #FFFFFF;
  border: none;
  z-index: 91;
  width: 30px;
  height: 31px;
  mask-image: url(./close.svg);
}
.dialogbox {
  border-radius: 10px;
  &::before {
    display: none!important;
  }
  padding: 0!important;
  margin: 0!important;
  height: fit-content;
  min-width: 60vw;
  max-width: 90vw;
  position: relative;
  background-color: #FFFFFF;
  z-index: 90;
  box-shadow: -4px 0px 15px rgba(0, 0, 0, 0.25);
  &.image {
    border-radius: 10px;
    display:flex;
    align-items: center;
    justify-content: center;
    max-width: 50vw;
    max-height: 90vh;
  }
}
.content-text {
  color: #787878;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 180%;
  padding-bottom: 20px;
}
.content {
  display: flex;
  padding: 0 30px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0;
  width: 100%;
  color: #787878;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 180%;
  padding-bottom: 20px;
}
}
</style>
